import { useGameContext } from "GameContext";
import GridDiv from "components/Map/GridDiv";
import {
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

import BasicButton from "components/General/BasicButton";
import IconButton from "components/General/IconButton";

import ModalWrapper, { OpenInterface } from "components/Wrappers/ModalWrapper";

export default function SimulationConfigModal({
  open,
  setOpen,

  cellData,
  mapActions={},
  muActions={},
  faunaActions={},
  startSim,
  gameState,
}: {
  open?: boolean,
  setOpen?: Dispatch<SetStateAction<boolean>>,
  mapActions?: Record<string, any>,
  muActions?: Record<string, any>,
  faunaActions?: Record<string, any>,
  cellData?: any,
  gameState?: any,
  startSim?: (waterRegime: number) => void,
}) {
  const {
    playerInfo,
    currentYear,
  } = useGameContext() as any;

  const waterRegimes = [1, 2, 3, 4, 5]
  const [selectedWaterRegime, setSelectedWaterRegime] = useState(1);

  return (
    <ModalWrapper open={open} setOpen={setOpen}>
      <h1 className="text-xl">Run a Simulation</h1>

      <br/>
      <p>Simulate the changes to the wetland based on the selected water regime and your actions</p>
      <br/>
      <div className="flex flex-row justify-between pb-2">
        <label className="">Select Water Regime</label>
      </div>
      <div className="flex flex-row justify-between border border-black py-2 px-1">
        { waterRegimes.map((waterRegime, i) => (
          <IconButton
            icon={`Water Regime ${waterRegime}`}
            key={i}
            onClick={() => {
              setSelectedWaterRegime(waterRegime)
            }}
            selected={selectedWaterRegime === waterRegime}
          />
        ))}
      </div>

      <div className="h-6"/>

      <label className="">Loaded Actions</label>

      <div className="h-96 flex justify-center">
        <GridDiv
          cellData={cellData}
          view={"land"}
          currentYear={currentYear}
          mapActions={mapActions}
          muActions={muActions}
          faunaActions={faunaActions}
          gameState={gameState}
          showLeft={playerInfo?.estate === "private"}
          showRight={playerInfo?.estate === "public"}
          showFauna={playerInfo?.role === "Hunter"}
        />
      </div>

      <div className="h-6"/>

      <div className="flex flex-row justify-between">
        <div />
        <BasicButton
          text={"Start Simulation"}
          onClick={() => {
            startSim?.(selectedWaterRegime);
            setOpen?.(false)
          }}
        />
      </div>
    </ModalWrapper>
  )
}
